import type { Department } from "./agentsApi";

export const DEPARTMENT_OPTIONS: { readonly value: Department | ""; readonly label: string }[] = [
  { value: "", label: "Brak" },
  { value: "SALES", label: "Dział sprzedaży" },
  { value: "OPERATIONS", label: "Dział Operacyjny" },
];
